export class TemperatureHelper {
	public static toFahrenheit(value: number): number {
		if (value === null) {
			return null;
		}
		return Math.round((value * 9) / 5 + 32);
	}
	public static toCelsius(value: number): number {
		if (value === null) {
			return null;
		}
		return parseFloat((((value - 32) * 5) / 9).toFixed(2));
	}
}
